import React from 'react';
import classnames from 'classnames';
import { useOverlayContext } from '../../../../hooks/useOverlayContext';
import FaveControl from '../../../legos/FaveControl';
import CommentControl from '../../../legos/CommentControl';
import s from './BottomInfoBar.scss';
const BottomInfoBar = ({ deviation , className  })=>{
    const { showCommentControl , showFaveControl  } = useOverlayContext(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, showFaveControl && /*#__PURE__*/ React.createElement(FaveControl, {
        deviation: deviation,
        className: s['stat']
    }), showCommentControl && /*#__PURE__*/ React.createElement(CommentControl, {
        deviation: deviation,
        className: s['stat']
    }));
};
BottomInfoBar.displayName = 'BottomInfoBar';
export default BottomInfoBar;
